<template>
  <!-- HERO -->
  <TopBanner
    layout="normal"
    currentPage="Our services"
    heading="Our services"
    bannerClass="banner-booking"
  />

  <!-- WHAT WE OFFER (FIRST) -->
  <section class="bg-slate-50/60 py-16 md:py-20">
    <div class="max-w-7xl mx-auto px-6 lg:px-10 xl:px-14">
      <h2 class="text-center uppercase text-[#0B6A1F] font-semibold text-[14px] tracking-[0.18em]">
        What we offer
      </h2>
      <div class="text-center text-slate-800 text-[22px] md:text-[34px] font-light mt-1">
        See What We Can Do For You
      </div>

      <!-- Large + small image cards -->
      <div class="grid grid-cols-2 gap-5 md:gap-7 mt-10 md:mt-12">
        <!-- Big: Airport -->
        <a
          href="/"
          class="group relative col-span-2 md:col-span-1 rounded-2xl overflow-hidden shadow-md ring-1 ring-black/5 feature-card"
        >
          <img src="/assets/8.jpeg" alt="Reliable Global Airport Transfer Services" class="w-full h-full object-cover aspect-[16/10]" />
          <div class="card-overlay" />
          <div class="card-caption">
            <div class="caption-bar group-hover:w-16" />
            <span class="caption-text">Airport transfer</span>
          </div>
        </a>

        <!-- Big: Chauffeur -->
        <a
          href="/"
          class="group relative col-span-2 md:col-span-1 rounded-2xl overflow-hidden shadow-md ring-1 ring-black/5 feature-card"
        >
          <img src="/assets/7.jpeg" alt="Premium Chauffeur Services Worldwide" class="w-full h-full object-cover aspect-[16/10]" />
          <div class="card-overlay" />
          <div class="card-caption">
            <div class="caption-bar group-hover:w-16" />
            <span class="caption-text">Chauffer Services</span>
          </div>
        </a>

        <!-- Small row (left) -->
        <div class="grid grid-cols-2 gap-5 md:gap-7 col-span-2 md:col-span-1">
          <div
            @click="router.push({ name: 'CarRental' })"
            class="group relative rounded-2xl overflow-hidden shadow-md ring-1 ring-black/5 feature-card cursor-pointer"
          >
            <img src="/assets/10.jpeg" alt="International Car Rental Selection" class="w-full h-full object-cover aspect-[4/3]" />
            <div class="card-overlay" />
            <div class="card-caption small">
              <div class="caption-bar group-hover:w-16" />
              <span class="caption-text">CAR RENTAL</span>
            </div>
          </div>

          <div
            class="group relative rounded-2xl overflow-hidden shadow-md ring-1 ring-black/5 feature-card cursor-pointer"
            @click="router.push({ name: 'MeetGreet' })"
          >
            <img src="/assets/4.jpg" alt="Professional Airport Meet and Greet Assistance" class="w-full h-full object-cover aspect-[4/3]" />
            <div class="card-overlay" />
            <div class="card-caption small">
              <div class="caption-bar group-hover:w-16" />
              <span class="caption-text">MEET & GREET</span>
            </div>
          </div>
        </div>

        <!-- Small row (right) -->
        <div class="grid grid-cols-2 gap-5 md:gap-7 col-span-2 md:col-span-1">
          <div
            class="group relative rounded-2xl overflow-hidden shadow-md ring-1 ring-black/5 feature-card cursor-pointer"
            @click="router.push({ name: 'BusesCoaches' })"
          >
            <img src="/assets/busescoaches.jpeg" alt="Global Bus and Coach Charter for Large Groups" class="w-full h-full object-cover aspect-[4/3]" />
            <div class="card-overlay" />
            <div class="card-caption small">
              <div class="caption-bar group-hover:w-16" />
              <span class="caption-text">BUSES & COACHES</span>
            </div>
          </div>

          <div
            class="group relative rounded-2xl overflow-hidden shadow-md ring-1 ring-black/5 feature-card cursor-pointer"
            @click="router.push({ name: 'Planmytrip' })"
          >
            <img src="/assets/5.jpg" alt="Special Event Transportation and Logistics" class="w-full h-full object-cover aspect-[4/3]" />
            <div class="card-overlay" />
            <div class="card-caption small">
              <div class="caption-bar group-hover:w-16" />
              <span class="caption-text">LEISURE & BUSSINESS SPECIAL EVENT</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- STORY / QUOTE (SECOND) -->
  <section class="max-w-7xl mx-auto px-6 lg:px-10 xl:px-14 my-16 md:my-24 grid md:grid-cols-2 gap-10 md:gap-14">
    <!-- Copy -->
    <section class="space-y-4">
      <h2 class="text-theme-gray-5 text-size-8 md:text-head-md">Vehitra World: A Journey Beyond Boundaries</h2>

      <p class="text-theme-gray-4 font-light text-size-6">
        In the heart of Riyad, back in 2001, Vehitra World embarked on a transformative journey in the kingdom of Saudi Arabia. With a visionary commitment to deliver unparalleled transportation solutions, our story unfolded alongside the evolution of technology.
      </p>
      <p class="text-theme-gray-4 font-light text-size-6">
        The inception of our first online booking platform, Carsirent.com, marked the intersection of innovation and convenience. Later, the addition of airporttransfers360.com expanded our reach, connecting us with travelers across GCC countries.
      </p>
      <p class="text-theme-gray-4 font-light text-size-6">
        As technology progressed, so did we. Through the unwavering trust and support of our local and international partners, Vehitra World's headquarters found a home in Bahrain in 2005, becoming the hub of our continuous success.
      </p>
      <p class="text-theme-gray-4 font-light text-size-6">
        Today, we proudly unveil a new chapter in our journey, introducing 'Vehitra World.' It's not just a name; it's a promise to cover more services and destinations, reflecting our commitment to evolution.
      </p>
      <p class="text-theme-gray-4 font-light text-size-6">
        This new platform is more than a website; it's a testament to our dedication. Crafted with local minds, it resonates with the pulse of our clients, meeting their exigencies and surpassing expectations.
      </p>
      <p class="text-theme-gray-4 font-light text-size-6">
        Vehitra World is not just about transportation; it's a gateway to experiences, a bridge connecting you to the world. Join us as we redefine the standards of global travel.
      </p>
      <p class="text-theme-gray-4 font-light text-size-6">
        Vehitra World — Where the journey transcends boundaries, and the world becomes your destination.
      </p>
      <p class="text-theme-gray-4 font-light text-size-6">
        To keep you satisfied, our Customer Support Team is available 24/7 to walk you through every step if you face any problem.
      </p>
    </section>

    <!-- Quote -->
    <section class="flex">
      <div class="rounded-2xl bg-white shadow-xl ring-1 ring-black/5 p-6 md:p-8 flex flex-col gap-8">
        <div class="flex items-start gap-4">
          <div>
            <font-awesome-icon size="2xl" icon="fa-solid fa-quote-right" class="text-theme-active" />
          </div>
          <div class="text-theme-gray-4 font-light text-size-7 md:text-head-md-2">
            As the founder of this company back in 2001, I had a dream of providing the most exceptional and luxurious transportation service to all
            our clients. It has been a long and challenging journey, but I am proud to say that we have become one of the most trusted and sought-after
            transportation companies in the industry.
          </div>
        </div>
        <div class="text-theme-gray-2 text-size-2 uppercase text-right">GHAZI HAMADE - CHAIRMAN &amp; CEO</div>
      </div>
    </section>
  </section>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router'
import TopBanner from '@/components/TopBanner.vue'

const router = useRouter()
</script>

<style scoped>
/* Card overlay + caption treatment shared by all offer cards */
.feature-card {
  transition: transform 380ms cubic-bezier(0.22, 0.61, 0.36, 1), box-shadow 380ms cubic-bezier(0.22, 0.61, 0.36, 1);
}
.feature-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 18px 40px -12px rgba(2, 6, 23, 0.35);
}

.card-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.55), rgba(0, 0, 0, 0) 65%);
  transition: opacity 300ms ease;
}
.feature-card:hover .card-overlay {
  opacity: 0.95;
}

.card-caption {
  position: absolute;
  left: 1rem;
  bottom: 1rem;
}
@media (min-width: 768px) {
  .card-caption { left: 2rem; bottom: 2rem; }
}
.card-caption.small { bottom: 1rem; left: 1rem; }

.caption-bar {
  height: 2px;
  width: 2rem;
  background: #fff;
  margin-bottom: 0.75rem;
  transition: width 300ms ease;
}
.caption-text {
  color: #fff;
  text-transform: uppercase;
  font-weight: 700;
  font-size: clamp(0.95rem, 1.8vw, 1.25rem);
  letter-spacing: 0.04em;
}
</style>